import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { stats, testimonials, faqs } from '@/mocks/data';

const breadcrumbItems = [
  { label: '首页', href: '/' },
  { label: '关于我们' },
];

const teamMembers = [
  { name: '匿名小编A', role: '主编', desc: '拥有10年娱乐记者经验，深度参与多起重大娱乐事件调查报道。' },
  { name: '匿名小编B', role: '资深编辑', desc: '前某知名娱乐周刊副主编，对娱乐圈内幕了如指掌。' },
  { name: '匿名小编C', role: '特约记者', desc: '常年潜伏在各大会所、片场的一线爆料人，人脉广布。' },
  { name: '匿名小编D', role: '数据分析师', desc: '擅长从海量数据中挖掘隐藏的娱乐八卦线索。' },
];

const timelineItems = [
  { year: '2023', title: '创立起步', desc: '51黑料网正式上线，初期仅有3人的编辑团队，怀揣着打造最真实娱乐资讯平台的梦想。' },
  { year: '2024', title: '快速发展', desc: '用户突破100万，成为中文互联网最具影响力的娱乐资讯平台之一，获得多个行业奖项。' },
  { year: '2025', title: '行业领先', desc: '月活用户突破500万，独家爆料内容超10万条，稳居吃瓜资讯平台第一梯队。' },
  { year: '2026', title: '全新升级', desc: '网站全面改版升级，新增黑料百科、独家资源等特色栏目，用户体验大幅提升。' },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('input[name="mobile_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      return;
    }

    setFormStatus('submitting');
    setFormError('');

    try {
      const formData = new FormData(form);
      const res = await fetch('https://readdy.ai/api/form/d95melih9roq6qfrc7dg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败';
        setFormError(serverMsg);
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请稍后重试');
      setFormStatus('error');
    }
  };

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <section className="px-4 md:px-6 py-8 md:py-12 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="mb-6">
              <Breadcrumb items={breadcrumbItems} />
            </div>

            <div className="text-center mb-14">
              <p className="text-xs font-semibold text-primary-500 tracking-widest uppercase mb-3">
                ABOUT US
              </p>
              <h1 className="text-3xl md:text-5xl font-heading font-black text-foreground-950 leading-tight tracking-tight">
                关于51黑料网
              </h1>
              <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                黑料吃瓜第一站 · 24小时不打烊 · 全网娱乐资源整合平台
              </p>
            </div>

            <div className="max-w-3xl mx-auto mb-16">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-5">
                品牌故事
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                <p>
                  51黑料网诞生于2023年，由一群热爱娱乐、追求真相的资深媒体人共同创建。我们深知，在信息爆炸的时代，吃瓜群众最需要的是一个<strong>真实、快速、全面</strong>的娱乐资讯聚合平台。
                </p>
                <p>
                  经过三年的发展，51黑料网已经从当初的小团队成长为拥有数百位独家线人的行业领先平台。我们的信息网络覆盖娱乐圈的每一个角落 —— 从一线明星到网红主播，从选秀节目到影视制作，我们致力于<strong>第一时间</strong>将最劲爆、最真实的爆料呈现给广大吃瓜群众。
                </p>
                <p>
                  我们坚持<strong>三重验证</strong>原则，确保每一条发布的内容都经过多方交叉确认。<strong>24小时不打烊</strong>的更新机制，让您无论何时打开网站，都能看到最新鲜的内容。因为我们相信：吃瓜，不应该有时差。
                </p>
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6 text-center">
                发展历程
              </h2>
              <div className="max-w-3xl mx-auto">
                <div className="relative">
                  <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-200 transform md:-translate-x-px"></div>
                  {timelineItems.map((item, idx) => (
                    <div key={item.year} className={`relative flex items-start mb-8 md:mb-10 ${idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                      <div className="flex-1 md:w-1/2 ml-10 md:ml-0 md:px-8">
                        <div className={`${idx % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                          <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded-full mb-2">
                            {item.year}
                          </span>
                          <h3 className="text-lg font-bold text-foreground-950">{item.title}</h3>
                          <p className="text-sm text-foreground-500 mt-1 leading-relaxed">{item.desc}</p>
                        </div>
                      </div>
                      <div className="absolute left-2 md:left-1/2 w-5 h-5 bg-primary-500 rounded-full border-4 border-background-50 transform md:-translate-x-2.5"></div>
                      <div className="flex-1 md:w-1/2 hidden md:block"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6 text-center">
                团队介绍
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
                {teamMembers.map(member => (
                  <div key={member.name} className="p-5 rounded-2xl bg-background-100 text-center">
                    <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-3">
                      <i className="ri-user-line text-2xl"></i>
                    </div>
                    <h4 className="text-sm font-bold text-foreground-950">{member.name}</h4>
                    <p className="text-xs text-primary-500 font-medium mt-0.5">{member.role}</p>
                    <p className="text-xs text-foreground-500 mt-2 leading-relaxed">{member.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-16 py-12 rounded-3xl bg-background-100">
              <div className="max-w-3xl mx-auto px-6">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">
                  平台数据
                </h2>
                <div className="flex items-center justify-center gap-0">
                  {stats.map((stat, idx) => (
                    <div key={stat.label} className="flex items-center">
                      {idx > 0 && (
                        <div className="w-px h-14 bg-foreground-200/40 mx-6 md:mx-12"></div>
                      )}
                      <div className="text-center">
                        <p className="text-3xl md:text-4xl font-heading font-black text-primary-500">
                          {stat.value}
                        </p>
                        <p className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6 text-center">
                用户口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {testimonials.map(t => (
                  <div key={t.id} className="p-5 rounded-2xl bg-background-100">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: t.rating }, (_, i) => (
                        <i key={i} className="ri-fire-fill text-accent-500 text-sm"></i>
                      ))}
                      {Array.from({ length: 5 - t.rating }, (_, i) => (
                        <i key={`e${i}`} className="ri-fire-line text-foreground-300 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">{t.content}</p>
                    <div className="flex items-center gap-3 pt-3 border-t border-background-200">
                      <img src={t.avatar} alt={t.name} className="w-9 h-9 rounded-full object-cover" />
                      <div>
                        <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                        <p className="text-xs text-foreground-400">{t.role}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-10 max-w-2xl mx-auto">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6 text-center">
                商务合作
              </h2>
              <p className="text-sm text-foreground-500 text-center mb-8 leading-relaxed">
                欢迎品牌方、广告主、内容创作者与我们合作。<br />
                请填写以下表单，我们将在1-3个工作日内与您联系。
              </p>

              <form data-readdy-form onSubmit={handleSubmit} className="space-y-4 p-6 md:p-8 rounded-2xl bg-background-100">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名 / 公司名称 <span className="text-primary-500">*</span></label>
                  <input
                    type="text" id="name" name="name" required
                    className="w-full px-4 py-3 rounded-xl bg-background-50 border border-background-200 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200"
                    placeholder="请输入您的姓名或公司名称"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">电子邮箱 <span className="text-primary-500">*</span></label>
                  <input
                    type="email" id="email" name="email" required
                    className="w-full px-4 py-3 rounded-xl bg-background-50 border border-background-200 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200"
                    placeholder="请输入您的电子邮箱"
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-foreground-700 mb-1.5">联系电话</label>
                  <input
                    type="tel" id="phone" name="phone"
                    className="w-full px-4 py-3 rounded-xl bg-background-50 border border-background-200 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200"
                    placeholder="请输入您的联系电话"
                  />
                </div>
                <div>
                  <label htmlFor="cooperation_type" className="block text-sm font-medium text-foreground-700 mb-1.5">合作类型 <span className="text-primary-500">*</span></label>
                  <select
                    id="cooperation_type" name="cooperation_type" required
                    className="w-full px-4 py-3 rounded-xl bg-background-50 border border-background-200 text-sm text-foreground-950 focus:outline-none focus:border-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    <option value="">请选择合作类型</option>
                    <option value="广告投放">广告投放</option>
                    <option value="内容合作">内容合作</option>
                    <option value="品牌赞助">品牌赞助</option>
                    <option value="线索提供">线索提供</option>
                    <option value="其他合作">其他合作</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">合作说明 <span className="text-primary-500">*</span></label>
                  <textarea
                    id="message" name="message" required maxLength={500}
                    rows={4}
                    className="w-full px-4 py-3 rounded-xl bg-background-50 border border-background-200 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200 resize-none"
                    placeholder="请简要描述您的合作需求（500字以内）"
                  ></textarea>
                </div>

                <input type="text" name="mobile_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="form-hp" />

                <button
                  type="submit"
                  disabled={formStatus === 'submitting'}
                  className="w-full py-3.5 bg-foreground-950 text-background-50 text-sm font-semibold rounded-xl hover:bg-foreground-800 disabled:opacity-60 disabled:cursor-not-allowed transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {formStatus === 'submitting' ? '提交中...' : '提交合作申请'}
                </button>

                {formStatus === 'success' && (
                  <p className="text-sm text-center text-green-600 font-medium">提交成功！我们将尽快与您联系。</p>
                )}
                {formStatus === 'error' && (
                  <p className="text-sm text-center text-red-500 font-medium">{formError}</p>
                )}
              </form>
            </div>

            <div className="max-w-2xl mx-auto">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6 text-center">
                常见问题
              </h2>
              <div className="space-y-3">
                {faqs.map((faq, idx) => (
                  <details key={idx} className="group rounded-2xl bg-background-100 overflow-hidden">
                    <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                      <span className="text-sm md:text-base font-bold text-foreground-950 pr-4">{faq.question}</span>
                      <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 group-open:bg-primary-500 group-open:text-background-50 transition-colors duration-200 flex-shrink-0">
                        <i className="ri-add-line group-open:ri-subtract-line text-sm"></i>
                      </span>
                    </summary>
                    <div className="px-5 md:px-6 pb-5 md:pb-6">
                      <p className="text-sm text-foreground-500 leading-relaxed">{faq.answer}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "关于51黑料网 - 黑料吃瓜第一站",
          "description": "51黑料网诞生于2023年，是黑料吃瓜第一站，致力于提供真实、快速、全面的娱乐资讯聚合服务。24小时不打烊，全网娱乐资源整合平台。",
          "url": "https://www.51heiliaobaike.com/about",
          "isPartOf": {
            "@type": "WebSite",
            "name": "51黑料网",
            "url": "https://www.51heiliaobaike.com/"
          }
        })
      }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "首页",
              "item": "https://www.51heiliaobaike.com/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "关于我们",
              "item": "https://www.51heiliaobaike.com/about"
            }
          ]
        })
      }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })
      }} />
    </>
  );
}